export const LOGIN_STEP = {
    SYSTEM: 'SYSTEM',
    ENTER_2FA: 'ENTER_2FA'
}